import { Injectable } from '@angular/core';
import { UserProfileSetting } from '../../core-data-model/UserProfileSetting.model';
import { ConfigurationService } from '../../system-configuration/Configuration.service';
import { ApiService } from '../../system-services/Api.service';
import {
    MessagingService,
    LogoutMessage
} from '../../system-services/Messaging.service';
import { UserProfileSettingTransformer } from '../../system-services/UserProfileSettings/UserProfileSetting.datatransform';

@Injectable({
    providedIn: 'root'
})
export class UserProfileSettingApi {
    constructor(
        private api: ApiService,
        private transform: UserProfileSettingTransformer,
        private config: ConfigurationService,
        private messageService: MessagingService
    ) {}

    getProfileSettings(): Promise<UserProfileSetting> {
        return this.api.get<any>(`/api/v1/userprofile`).then(([data]) => {
            if (data && data.settings) {
                return this.transform.serverToClient(JSON.parse(data.settings));
            }
            return new UserProfileSetting();
        });
    }

    setProfileSettings(setting: UserProfileSetting) {
        const userProfileSettingServer = this.transform.clientToServer(setting);
        return this.api.patch(`/api/v1/userprofile`, {
            settings: JSON.stringify(userProfileSettingServer)
        });
    }

    setDefaultFolder(defaultFolderGuid: string) {
        return this.api.patch(`/api/v1/userprofile`, { defaultFolderGuid });
    }
    setUserIsUsingBetaSite(isUsingBetaSite: boolean) {
        return this.api
            .patch(`/api/v1/userprofile`, { isUsingBetaSite })
            .then(() => {
                if (!isUsingBetaSite) {
                    this.messageService.sendMessage(
                        new LogoutMessage(
                            `${this.config.getClassicURL()}?classicBehavior=true`
                        )
                    );
                }
            });
    }

    setUserAcknowledgedCogBestPractices(
        hasAcknowledgedCogBestPractices: boolean
    ) {
        return this.api.patch(`/api/v1/userprofile`, {
            hasAcknowledgedCogBestPractices
        });
    }

    setUserInfo(oldUsername: string, username: string, phone: string) {
        const update = {
            OldUserName: oldUsername,
            UserName: username,
            Email: username,
            Phone: phone
        };
        return this.api.patch(`/api/v1/myprofile`, update);
    }

    resetPassword(newPassword: string, oldPassword: string) {
        const update = {
            NewPassword: newPassword,
            OldPassword: oldPassword
        };
        return this.api.patch(`/api/v1/password`, update);
    }
}
